/* eslint-disable max-lines */

import { inject, observer } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { LocalizedComponentProps } from 'bernie-l10n';
import { updateSearch } from 'bernie-core';

import { IClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { PropertySearchMapTrigger } from '@shared-ui/lodging-property-search';
import { SortAndFiltersViewType } from '@shared-ui/search-tools-lodging';

import { changeView, View, ViewTracker } from 'src/common/stores/contexts/viewTracker';
import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { UitkEGMapsQualifier } from 'uitk-react-map';

import { DynamicSearchMapWrapper } from './dynamic-search-map-wrapper';
import { EGMapConfiguration } from '@eg-maps/core';
import { parse } from 'query-string';
import { UniversalSortFilterWrapper } from '../sort-filter/universal-sort-filter';

const egMapConfiguration: EGMapConfiguration = {
  markers: {
    place: {
      zIndex: {
        unknown: 0,
      },
    },
    property: {
      zIndex: {
        [`${UitkEGMapsQualifier.NOT_CLUSTERED}`]: 0,
      },
    },
  },
};

export interface MapPreviewProps extends LocalizedComponentProps, Partial<RouteComponentProps> {
  multiItem?: MultiItemStore;
  tracker: IClickstreamAnalytics;
  viewTracker: ViewTracker;
}

// @ts-ignore
@withRouter
@inject('multiItem')
@observer
export class MapPreview extends React.Component<MapPreviewProps> {
  private mapBtn: any;

  constructor(props: MapPreviewProps) {
    super(props);

    this.onMapDialogClosed = this.onMapDialogClosed.bind(this);
    this.mapBtn = React.createRef();
  }

  public render() {
    const { location } = this.props;
    const locationSearch = location?.search ? (parse(location.search) as Record<string, string>) : undefined;

    const inputs = {
      destination: { regionName: locationSearch?.destination, pinnedPropertyId: locationSearch?.selected },
    };

    const triggerRef = (mapBtn: any) => {
      this.mapBtn = mapBtn;
    };

    const dynamicSearchMapWrapper = (
      <DynamicSearchMapWrapper
        cfg={egMapConfiguration}
        clientPadding="32px"
        onMapDialogClosed={this.onMapDialogClosed}
        filterComponent={<UniversalSortFilterWrapper view={SortAndFiltersViewType.FILTER_DIALOG} />}
        triggerRef={triggerRef}
      />
    );

    return <PropertySearchMapTrigger inputs={inputs}>{dynamicSearchMapWrapper}</PropertySearchMapTrigger>;
  }

  private onMapDialogClosed(): void {
    const { history, location, multiItem, tracker, viewTracker } = this.props;
    history &&
      location &&
      updateSearch({
        history,
        location,
        newParams: {
          pwaOverlay: '',
        },
      });

    changeView(tracker, viewTracker, View.LISTINGS, multiItem?.getPackageType() ?? undefined);

    if (this.mapBtn && typeof this.mapBtn.focus === 'function') {
      this.mapBtn.focus();
    }
  }
}
